import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";

export class AuthenticationHeadersBuilder {
  private authenticationRepository: AuthenticationRepository;

  constructor(authenticationRepository: AuthenticationRepository) {
    this.authenticationRepository = authenticationRepository;
  }

  public build(): Headers {
    const headers = new Headers();
    headers.set("Content-Type", "application/json");
    headers.set(
      "Authorization",
      `Bearer ${this.authenticationRepository.getAccessToken()}`,
    );
    return headers;
  }
}
